import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Cross, Conditional } from '@cashfree-intl/coherent';

import { CREATED, INSTANT_SETTLEMENTS_REGISTRATION_STATUS } from '../constants';
import { StyledBanner } from '../styled';

const {
  ACTIVE,
  IN_PROGRESS,
  IN_REVIEW,
  RISK_REJECTED,
  REJECTED,
} = INSTANT_SETTLEMENTS_REGISTRATION_STATUS;

const InstantSettlementsActivationBanner = ({
  onClose,
  status,
  isSoftApproved,
}) => (
  <>
    <Conditional
      if={isSoftApproved || [IN_PROGRESS, IN_REVIEW].includes(status)}
    >
      <StyledBanner>
        <Alert size="md" type="info" compact bordered>
          Instant settlements is activated for your account. You will be
          notified when your daily limits are upgraded.
          <Cross
            size="md"
            className="ml-3"
            onClick={onClose}
            data-event-name="Icon_Cross"
          />
        </Alert>
      </StyledBanner>
    </Conditional>
    <Conditional if={status === ACTIVE}>
      <StyledBanner>
        <Alert size="md" type="success" compact bordered>
          Congratulations, your instant settlements has been activated with full
          limit.
          <Cross
            size="md"
            className="ml-3"
            onClick={onClose}
            data-event-name="Icon_Cross"
          />
        </Alert>
      </StyledBanner>
    </Conditional>
    <Conditional if={[REJECTED, RISK_REJECTED].includes(status)}>
      <StyledBanner>
        <Alert size="md" type="danger" compact bordered>
          Instant settlements activation failed. Contact care@cashfree.com for
          further help.
          <Cross
            size="md"
            className="ml-3"
            onClick={onClose}
            data-event-name="Icon_Cross"
          />
        </Alert>
      </StyledBanner>
    </Conditional>
    <Conditional if={status === CREATED}>
      <Alert className="mb-2" size="md" type="info" compact bordered>
        Instant Settlements request is in review, you will be notified when your
        request has been approved.
        <Cross
          size="md"
          className="ml-3"
          onClick={onClose}
          data-event-name="Icon_Cross"
        />
      </Alert>
    </Conditional>
  </>
);

InstantSettlementsActivationBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  isSoftApproved: PropTypes.number.isRequired,
};

export default InstantSettlementsActivationBanner;
